import { ActionTree } from "vuex";
import { IPropertyEditState } from "../property-states.store";

const relationActions: ActionTree<IPropertyEditState, {}> = <ActionTree<IPropertyEditState, {}>>{
}

export default relationActions;